export default "__VITE_ASSET__CzuAl9hA__"